<div class="container content">
    <div class="row">
        <div class="col-md-12">
            <h5 class="title-step" align="center">
                <img src="./assets/img/credit-card.svg" class="img-fluid ico-title" width="20">
                Confirmación del contrato
            </h5>
        </div>
    </div>
</div>

<app-cliente></app-cliente>
<app-resumen [ariaExpanded]="ariaExpanded" [showCollapse]="showCollapse"></app-resumen>

<!--------------------- GDPR ------------------------>
<!--------------------------------------------------->


<!-- Check -->
<div class="container" [formGroup]="form">
    <div class="area-check">
        <div class="checkbox icheck-primary">
            <input type="checkbox" id="commercial_communications" class="accept-check" formControlName="commercial_communications"/>
            <label for="commercial_communications">
                Deseo recibir comunicaciones comerciales de ORANGE ajustadas a mi perfil comercial según los datos derivados del Servicio
                como tráfico, navegación y localización.
            </label>
            <mat-error *ngIf="errorHandling('commercial_communications', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>

        <div class="checkbox icheck-primary">
            <input type="checkbox" id="third_party_commercial_communications" class="accept-check"
                   formControlName="third_party_commercial_communications"/>
            <label for="third_party_commercial_communications">Deseo recibir publicidad de compañías con las que ORANGE colabora que ofrecen productos y servicios de
                telecomunicaciones, financieros, seguros, tecnología, energía, audiovisual, seguridad, educación, ocio,
                automoción, publicidad, gran consumo.
            </label>
            <mat-error *ngIf="errorHandling('third_party_commercial_communications', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>

        <div class="checkbox icheck-primary">
            <input type="checkbox" id="orange_companies_data_transfer" class="accept-check" formControlName="orange_companies_data_transfer"/>
            <label for="orange_companies_data_transfer">
                Consiento la cesión de mis datos a sociedades participadas y empresas del Grupo Orange, incluido mi perfil comercial, para
                la remisión por su parte de acciones comerciales personalizadas (el listado completo
                de empresas y su actividad está disponible en <a href="http://www.orange.es" target="_blank">www.orange.es</a>).
            </label>
            <mat-error *ngIf="errorHandling('orange_companies_data_transfer', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>

        <div class="checkbox icheck-primary">
            <input type="checkbox" id="data_treatment" class="accept-check" formControlName="data_treatment"/>
            <label for="data_treatment">
                Consiento la elaboración de un perfil comercial, basado en información proveniente de terceros, que permita a ORANGE la adopción
                de decisiones automatizadas.
            </label>
            <mat-error *ngIf="errorHandling('data_treatment', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>

        <div class="checkbox icheck-primary">
            <input type="checkbox" id="third_party_data_transfer" class="accept-check" formControlName="third_party_data_transfer"/>
            <label for="third_party_data_transfer">
                Consiento la comunicación de mis datos, incluido mi perfil comercial, a compañías con las que Orange colabora en los siguientes
                sectores: telecomunicaciones, financieros, seguros, tecnología, energía, audiovisual, seguridad, educación, ocio, automoción,
                publicidad y gran consumo, para que puedan facilitarme información comercial adaptada a mis gustos y preferencias.
            </label>
            <mat-error *ngIf="errorHandling('third_party_data_transfer', 'required')">
                <small class="ps-4 ms-1">Campo obligatorio.</small>
            </mat-error>
        </div>

    </div><!-- ./ area check -->
</div>


<!--------------------- ./GDPR ------------------------>
<!----------------------------------------------------->


<div class="container mt-4" [formGroup]="form" *ngIf="pdv != null && pdv.info.telesales === 1">
    <div class="card">
        <div class="bg-white px-3 pt-4 pb-3">
            <div class="row">
                <div class="col-xl-12">
                    <mat-form-field>
                        <mat-label>Código de campaña *</mat-label>
                        <input type="text" matInput formControlName="campaign_code">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>

<br><br>

<!--------- ACTIVAR SERVICIOS ------------>
<!---------------------------------------->

<div class="container firma"><br>

    <div class="row">
        <button type="button" [disabled]="isLoading" class="btn btn-black-outline btn-block mb-5 spinner" (click)="activate()">
            <span *ngIf="isLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            {{textDefault}}
        </button>
    </div>

</div>


<!--------- ./ ACTIVAR SERVICIOS ------------>
<!-------------------------------------------->
